<template>
  <div>
    <button class="btn dealers_btn" @click="unlinkVehicle">
      {{ $t("text.clickButtons.unLinkVehicle") }}
    </button>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {},
  methods: {
    unlinkVehicle() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Drivers/RemoveVehicle/${this.$route.query.driverId}?vehicleId=${this.data.id}`,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: this.$t("text.requests.success"),
            type: "success",
            duration: 5000,
          });
          this.$router.push({ name: "drivers" });
        })
        .catch((error) => {});
    },
  },
};
</script>
